import { Spin } from 'antd'
import { useTranslation } from 'react-i18next'

import {
  ContainerTable,
  CustomHeaderTable,
  DataCellWrapper,
  EffortWrapper,
  HeaderCelDate,
  HeaderCellWrapper,
  TableCustom,
  TableWrapper,
  Wrappertable,
} from '@/components/pages/ClientDevice/styles'
import { GetClientDeviceByRangeDayResponse } from '@/types/apis/clientDevice'
import { formatYMD } from '@/utils/date'

type Props = {
  responseClientDeviceByRangeDay: GetClientDeviceByRangeDayResponse
  responseClientDeviceByRangeDayLoading?: boolean
}

const ClientDeviceByRangeDayTable = ({
  responseClientDeviceByRangeDay,
  responseClientDeviceByRangeDayLoading,
}: Props) => {
  const { t } = useTranslation()
  const dataSource = responseClientDeviceByRangeDay

  return (
    <ContainerTable>
      <Spin spinning={responseClientDeviceByRangeDayLoading}>
        <TableWrapper>
          <EffortWrapper>{t('components.pages.clientDevice.listReport.table.hour')}</EffortWrapper>
          <Wrappertable>
            <TableCustom>
              <tbody>
                <CustomHeaderTable>
                  <HeaderCelDate>{t('components.pages.clientDevice.listReport.table.date')}</HeaderCelDate>
                  {dataSource[0]?.items.map((clientDevice, index) => (
                    <HeaderCellWrapper key={index}>{clientDevice.name}</HeaderCellWrapper>
                  ))}

                  <HeaderCellWrapper>{t('components.pages.clientDevice.listReport.table.total')}</HeaderCellWrapper>
                </CustomHeaderTable>

                {dataSource.map((clientDevice, index) => (
                  <tr key={index}>
                    <DataCellWrapper>{formatYMD(clientDevice.date)}</DataCellWrapper>
                    {clientDevice.items.map((item, index) => (
                      <DataCellWrapper key={index}>
                        {item.workingTime ? item.workingTime.toFixed(1) : undefined}
                      </DataCellWrapper>
                    ))}
                    <DataCellWrapper>
                      {clientDevice.totalWorkingTime ? clientDevice.totalWorkingTime.toFixed(1) : undefined}
                    </DataCellWrapper>
                  </tr>
                ))}
              </tbody>
            </TableCustom>
          </Wrappertable>
        </TableWrapper>
      </Spin>
    </ContainerTable>
  )
}
ClientDeviceByRangeDayTable.displayName = 'ClientDeviceByRangeDayTable'
export default ClientDeviceByRangeDayTable
